import { motion } from 'framer-motion'

const PropertyCard = ({ property }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-white rounded-2xl p-6 shadow-lg card-hover"
    >
      <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-4">
        <span className="text-3xl">{property.icon}</span>
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3">{property.title}</h3>
      <p className="text-gray-600 leading-relaxed">{property.description}</p>
    </motion.div>
  )
}

export default PropertyCard